import { getAnnotationsOfUser, getSlidesToAnnotate } from "@/api/craiyon";
import { Annotation, normalize, Slide } from "@/store/helper";
import Vue from "vue";

const MODULE = "contributions/";
const _LOADING = "LOADING";
const _TOGGLE_LOADING = "_TOGGLE_LOADING";
const _RESET = "_RESET";
const _FIND = "FIND";
const _LIST = "LIST";
const _TOTAL = "TOTAL";
const _LOAD_CONTRIBUTIONS = "_LOAD_CONTRIBUTIONS";

export const LOAD_CONTRIBUTIONS = MODULE + _LOAD_CONTRIBUTIONS;
export const LIST = MODULE + _LIST;
export const FIND = MODULE + _FIND;
export const TOTAL = MODULE + _TOTAL;
export const LOADING = MODULE + _LOADING;

const state = {
  loading: false,
  byId: {},
  allIds: undefined
};

const getters = {
  [_TOTAL](state) {
    return state.rawSlides.count;
  },
  [_FIND](state) {
    return id => state.byId[id];
  },
  [_LIST](state, getters) {
    if (state.allIds === undefined) return undefined;
    return state.allIds.map(id => getters[_FIND](id)).filter(e => e);
  }
};

const mutations = {
  add: (state, item) => {
    if (state.allIds === undefined) state.allIds = [];
    for (let key of Object.keys(item)) {
      Vue.set(state.byId, key, item[key]);
      if (state.allIds.includes(key)) return;
      state.allIds.push(key);
    }
  },
  [_TOGGLE_LOADING](state) {
    state.loading = !state.loading;
  },
  [_RESET](state) {
    state.byId = {};
    state.allIds = [];
  }
};

const actions = {
  async [_LOAD_CONTRIBUTIONS]({ commit, state, rootGetters, rootState }) {
    if (state.allIds) return;
    commit(_RESET);
    commit(_TOGGLE_LOADING);
    const token = rootGetters.token;
    const annotations = await getAnnotationsOfUser(token);
    annotations.forEach(s => {
      const flat = normalize(s, Annotation);
      commit("add", flat.entities.annotation);
      commit("annotationClass/add", flat.entities.annotationClass, {
        root: true
      });
    });
    commit(_TOGGLE_LOADING);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
